module.exports = __webpack_public_path__ + "files/8665a1cec48edee8cebfcb0ba34eb976.png";